











import Vue from 'vue';
import {Component} from 'vue-property-decorator';

import {AppConstants} from '@app/store/AppConstants';

@Component
export default class CubHeader extends Vue {
    public orgName: string = AppConstants.orgName;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/Header.vue